export default __webpack_public_path__ + "static/media/storageUnit1-afterA-768w.2c72d531.avif";